export enum SelectAtsVacancyModalType {
  Contacting = 'contacting',
  Scheduling = 'scheduling',
  Matching = 'matching',
}
